(() => {
  document.querySelectorAll('[data-shpyda-product]').forEach((root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const form = root.querySelector('[data-product-form]');

    const sizeGuideModal = root.querySelector('[data-size-guide-modal]');
    const sizeGuideOpen = root.querySelector('[data-size-guide-open]');
    const sizeGuideCloseButtons = root.querySelectorAll('[data-size-guide-close]');

    const closeSizeGuide = () => {
      if (!sizeGuideModal) return;
      sizeGuideModal.hidden = true;
      document.body.classList.remove('shpyda-modal-open');
      sizeGuideOpen?.focus();
    };

    sizeGuideOpen?.addEventListener('click', () => {
      if (!sizeGuideModal) return;
      sizeGuideModal.hidden = false;
      document.body.classList.add('shpyda-modal-open');
      sizeGuideModal.querySelector('.shpyda-size-guide-modal__close')?.focus();
    });

    sizeGuideCloseButtons.forEach((button) => {
      button.addEventListener('click', closeSizeGuide);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && sizeGuideModal && !sizeGuideModal.hidden) {
        closeSizeGuide();
      }
    });

    root.querySelectorAll('.shpyda-product-video video').forEach((video) => {
      video.muted = true;
      video.playsInline = true;
      const playPromise = video.play();
      if (playPromise?.catch) playPromise.catch(() => {});
    });


    const variantsNode = root.querySelector('[data-product-json]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const variantId = root.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-product-price]');
    const submit = root.querySelector('[data-add-to-cart]');
    const message = root.querySelector('[data-product-message]');
    const stage = root.querySelector('[data-product-media-stage]');
    const template = root.querySelector('[data-product-media-template]');
    const backLink = root.querySelector('[data-history-back]');

    backLink?.addEventListener('click', (event) => {
      if (window.history.length > 1 && document.referrer) {
        event.preventDefault();
        window.history.back();
      }
    });

    const money = (cents) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'GBP'
        }).format(cents / 100);
      } catch (_) {
        return `£${(cents / 100).toFixed(2)}`;
      }
    };

    const selectedOptions = () => [...root.querySelectorAll('[data-option-position]')].map((field) => field.querySelector('[data-option-input]:checked')?.value);

    const updateVariant = () => {
      const options = selectedOptions();
      const variant = variants.find((item) => item.options.every((option, index) => option === options[index]));
      if (!variant) return;
      variantId.value = variant.id;
      price.innerHTML = `${variant.compare_at_price > variant.price ? `<s>${money(variant.compare_at_price)}</s>` : ''}<span>${money(variant.price)}</span>`;
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? (submit.dataset.addLabel || 'Add to cart') : (submit.dataset.soldLabel || 'Sold out');
      if (variant.featured_media?.id) root.querySelector(`[data-product-thumb][data-media-id="${variant.featured_media.id}"]`)?.click();
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    root.querySelectorAll('[data-option-input]').forEach((input) => input.addEventListener('change', updateVariant));

    root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      const input = root.querySelector('[data-quantity-input]');
      input.value = Math.max(1, Number(input.value || 1) - 1);
    });
    root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      const input = root.querySelector('[data-quantity-input]');
      input.value = Math.max(1, Number(input.value || 1) + 1);
    });

    root.querySelectorAll('[data-product-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const id = thumb.dataset.mediaId;
        const source = template?.content.querySelector(`[data-media-template-id="${id}"]`);
        if (!source || !stage) return;
        stage.innerHTML = source.innerHTML;
        root.querySelectorAll('[data-product-thumb]').forEach((item) => item.setAttribute('aria-current', String(item === thumb)));
      });
    });

    const videoScroller = root.querySelector('[data-video-scroller]');
    const videoPrevious = root.querySelector('[data-video-previous]');
    const videoNext = root.querySelector('[data-video-next]');

    const videoStep = () => {
      const card = videoScroller?.querySelector('.shpyda-product-video');
      if (!card) return 300;
      const styles = window.getComputedStyle(videoScroller);
      return card.getBoundingClientRect().width + parseFloat(styles.gap || '0');
    };

    videoPrevious?.addEventListener('click', () => {
      videoScroller?.scrollBy({ left: -videoStep(), behavior: 'smooth' });
    });
    videoNext?.addEventListener('click', () => {
      videoScroller?.scrollBy({ left: videoStep(), behavior: 'smooth' });
    });

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      submit.disabled = true;
      message.textContent = '';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'Unable to add this item.');
        message.textContent = 'Added to cart.';
        window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
      } catch (error) {
        message.textContent = error.message;
        submit.disabled = false;
      }
    });
  });
})();
